import Vue from "vue";
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(CKEditor);